/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsCatagoryGetSubcategoriesData } from './mands-catagory-get-subcategories.data';
import { IMandsCatagoryGetSubcategoriesProps } from './mands-catagory-get-subcategories.props.autogenerated';

import Category from '../../themes/mands/views/custom-components/category';
/**
 *
 * MandsCatagoryGetSubcategories component
 * @extends {React.PureComponent<IMandsCatagoryGetSubcategoriesProps<IMandsCatagoryGetSubcategoriesData>>}
 */
export default class MandsCatagoryGetSubcategories extends React.PureComponent<
    IMandsCatagoryGetSubcategoriesProps<IMandsCatagoryGetSubcategoriesData>
> {
    public render(): JSX.Element {
        const { config, data, context, id, typeName } = this.props;

        const category = data && data.category && data.category.result;
        const subCategories = category && category.Children && category.Children.length > 0 && category.Children;
        return (
            <div>
                <div className='sub-category-headline'>
                    <h2>{category && category.Name}</h2>
                </div>
                <div className='sub-category-wrap'>
                    {subCategories &&
                        subCategories.map(subCategory => {
                            // tslint:disable-next-line: jsx-key
                            return (
                                <div className='col-sm-6 col-md-4 col-lg-3' key={id}>
                                    <Category
                                        context={context}
                                        id={id}
                                        typeName={typeName}
                                        data={{ category: subCategory }}
                                        imageSettings={config.imageSettings}
                                        page={'categories'}
                                    />
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    }
}
